import { useEffect, useMemo, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import apiUrl from "../Apiurl";
import stilePulsanti from "../interfaccia/stilePulsanti";

function PubbWeekManual({ temaColori = "rootTema" }) {
  const { getAccessTokenSilently, user } = useAuth0();
  const [token, setToken] = useState("");
  const [form, setForm] = useState({
    date: "",
    totalArticoli: "",
    withStock: "",
    publishedTotal: "",
    publishedWithStock: "",
    imagesTotal: "",
    imagesWithStock: "",
  });
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadToken = async () => {
      try {
        const t = await getAccessTokenSilently();
        setToken(t);
      } catch (err) {
        console.error("Token error", err);
      }
    };
    loadToken();
  }, [getAccessTokenSilently, user?.sub]);

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setLoading(true);
    setError("");
    setResult(null);
    try {
      const payload = {
        date: form.date,
        totalArticoli: Number(form.totalArticoli || 0),
        withStock: Number(form.withStock || 0),
        publishedTotal: Number(form.publishedTotal || 0),
        publishedWithStock: Number(form.publishedWithStock || 0),
        imagesTotal: Number(form.imagesTotal || 0),
        imagesWithStock: Number(form.imagesWithStock || 0),
      };
      const response = await fetch(
        `${apiUrl}/moda/publishing/weekly-stats/manual`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const body = await response.json();
      if (!response.ok || !body.success) {
        throw new Error(body.error || "Errore nel salvataggio.");
      }
      setResult(body.data);
    } catch (err) {
      setError(err.message || "Errore imprevisto");
    } finally {
      setLoading(false);
    }
  };

  const canSubmit = useMemo(() => token && form.date, [token, form.date]);

  return (
    <div className={`${temaColori} pa3`}>
      <h2 className="ma0 mb3">Snapshot settimanale pubblicazioni (manuale)</h2>
      <div className="sfondoBiancoTema br3 pa3 shadow-1">
        <form onSubmit={handleSubmit}>
          <div className="mb3">
            <label className="db b mb1" htmlFor="date">
              Data (appartiene alla settimana da salvare)
            </label>
            <input
              id="date"
              name="date"
              type="date"
              className="input-reset ba b--light-gray br2 pa2 w5"
              value={form.date}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-wrap">
            {[
              { name: "totalArticoli", label: "Articoli totali" },
              { name: "withStock", label: "Articoli con stock" },
              { name: "publishedTotal", label: "Pubblicati totali" },
              { name: "publishedWithStock", label: "Pubblicati con stock" },
              { name: "imagesTotal", label: "Immagini totali" },
              { name: "imagesWithStock", label: "Immagini con stock" },
            ].map((field) => (
              <div key={field.name} className="mr3 mb3">
                <label className="db mb1" htmlFor={field.name}>
                  {field.label}
                </label>
                <input
                  id={field.name}
                  name={field.name}
                  type="number"
                  min="0"
                  className="input-reset ba b--light-gray br2 pa2 w5"
                  value={form[field.name]}
                  onChange={handleChange}
                />
              </div>
            ))}
          </div>
          <button
            type="submit"
            className={stilePulsanti.buttonClasses}
            disabled={!canSubmit || loading}
          >
            {loading ? "Salvataggio..." : "Salva settimana"}
          </button>
        </form>
        {error && (
          <div className="bg-washed-red dark-red pa2 br2 mt3">{error}</div>
        )}
        {result && (
          <div className="bg-washed-green dark-green pa2 br2 mt3">
            Salvato settimana {result.year}-W{String(result.isoWeek).padStart(2, "0")} (
            {result.weekStart?.slice ? result.weekStart.slice(0, 10) : ""})
          </div>
        )}
      </div>
    </div>
  );
}

export default PubbWeekManual;
